
const ReactAppStage = process.env.REACT_APP_API_STAGE;
export const TEST_API_BASE_URL = "https://weddingtestapi.riolabz.com/api/v1/"
export const LIVE_API_BASE_URL = "https://api.eventoq.in/api/v1/"
export const UAT_API_BASE_URL = "https://eventoquatapi.riolabz.com/api/v1/"

export const RAZORPAY_KEY =
  (process.env.REACT_APP_API_STAGE == "Dev" || process.env.REACT_APP_API_STAGE == "Uat")
    ? process.env.REACT_APP_RAZORPAY_TEST_KEY
    : process.env.REACT_APP_RAZORPAY_LIVE_KEY;


const dev = {
  API_ENDPOINT_URL:
    ReactAppStage == "Dev"
      ? TEST_API_BASE_URL
      : ReactAppStage == "Uat"
        ? UAT_API_BASE_URL
        : LIVE_API_BASE_URL,
};

const prod = {
  API_ENDPOINT_URL:
    ReactAppStage == "Dev"
      ? TEST_API_BASE_URL
      : ReactAppStage == "Uat"
        ? UAT_API_BASE_URL
        : LIVE_API_BASE_URL,
};

const test = {
  API_ENDPOINT_URL:
    ReactAppStage == "Dev"
      ? TEST_API_BASE_URL
      : ReactAppStage == "Uat"
        ? UAT_API_BASE_URL
        : LIVE_API_BASE_URL,
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case 'development':
      return dev;
    case 'production':
      return prod;
    case 'test':
      return test;
    default:
      break;
  }
};

export const env = getEnv();
